import {
  fetchCustomProducts,
  fetchInvestPlatforms,
  fetchManagers,
  fetchPortfolioManagers,
  fetchProducts,
} from "@ls/entity-mapping-service";
import { exchange } from "@ls/js-fetch";

const GroupType = {
  CUSTOM: "CUSTOM",
  PRODUCT: "PRODUCT",
  MANAGER: "MANAGER",
  INVEST_PLATFORM: "INVEST_PLATFORM",
  CLIENT_PORTFOLIO_MGR: "CLIENT_PORTFOLIO_MGR",
  GROUP: "GROUP",
  COMP: "COMP",
};

const GroupTypeEntity = {
  [GroupType.CUSTOM]: {
    value: GroupType.CUSTOM,
    label: "Custom",
    groupingValue: "custom",
    groupingKey: "id",
    comboboxValueKey: "id",
    comboboxLabelKey: "description",
    groupPickerColumnDefs: [
      {
        headerName: "ID",
        field: "id",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Investment Team",
        field: "investmentTeam",
        width: 250,
        suppressSizeToFit: true,
      },
      {
        headerName: "Description",
        field: "description",
      },
    ],
    fetchGroups: fetchCustomProducts,
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.investmentTeam === o2.investmentTeam) {
        if (o1.description === o2.description) {
          return 0;
        }
        if (!o1.description) {
          return -1;
        }
        if (!o2.description) {
          return 1;
        }
        return o1.description > o2.description ? 1 : -1;
      }
      if (!o1.investmentTeam || o1.investmentTeam === "") {
        return 1;
      }
      if (!o2.investmentTeam || o2.investmentTeam === "") {
        return -1;
      }
      return o1.investmentTeam > o2.investmentTeam ? 1 : -1;
    },
  },
  [GroupType.PRODUCT]: {
    value: GroupType.PRODUCT,
    label: "Product",
    groupingValue: "product",
    groupingKey: "id",
    comboboxValueKey: "id",
    comboboxLabelKey: "description",
    groupPickerColumnDefs: [
      {
        headerName: "ID",
        field: "id",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Product",
        field: "description",
        width: 250,
      },
    ],
    fetchGroups: fetchProducts,
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.description === o2.description) {
        return 0;
      }
      if (!o1.description) {
        return -1;
      }
      if (!o2.description) {
        return 1;
      }
      return o1.description > o2.description ? 1 : -1;
    },
  },
  [GroupType.MANAGER]: {
    value: GroupType.MANAGER,
    label: "Manager",
    groupingValue: "manager",
    groupingKey: "id",
    comboboxValueKey: "id",
    comboboxLabelKey: "lastName",
    groupPickerColumnDefs: [
      {
        headerName: "ID",
        field: "id",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Last Name",
        field: "lastName",
      },
      {
        headerName: "First Name",
        field: "firstName",
      },
    ],
    fetchGroups: fetchManagers,
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.lastName === o2.lastName) {
        if (o1.firstName === o2.firstName) {
          return 0;
        }
        if (!o1.firstName) {
          return -1;
        }
        if (!o2.firstName) {
          return 1;
        }
        return o1.firstName > o2.firstName ? 1 : -1;
      }
      if (!o1.lastName || o1.lastName === "") {
        return 1;
      }
      if (!o2.lastName || o2.lastName === "") {
        return -1;
      }
      return o1.lastName > o2.lastName ? 1 : -1;
    },
  },
  [GroupType.INVEST_PLATFORM]: {
    value: GroupType.INVEST_PLATFORM,
    label: "Investment Platform",
    groupingValue: "invest_platform",
    groupingKey: "id",
    comboboxValueKey: "id",
    comboboxLabelKey: "desc",
    groupPickerColumnDefs: [
      {
        headerName: "ID",
        field: "id",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Investment Platform",
        field: "desc",
        width: 250,
      },
    ],
    fetchGroups: fetchInvestPlatforms,
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.desc === o2.desc) {
        return 0;
      }
      if (!o1.desc) {
        return -1;
      }
      if (!o2.desc) {
        return 1;
      }
      return o1.desc > o2.desc ? 1 : -1;
    },
  },
  [GroupType.CLIENT_PORTFOLIO_MGR]: {
    value: GroupType.CLIENT_PORTFOLIO_MGR,
    label: "Client Portfolio Manager",
    groupingValue: "client_portfolio_manager",
    groupingKey: "id",
    comboboxValueKey: "id",
    comboboxLabelKey: "lastName",
    groupPickerColumnDefs: [
      {
        headerName: "ID",
        field: "id",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Last Name",
        field: "lastName",
      },
      {
        headerName: "First Name",
        field: "firstName",
      },
    ],
    fetchGroups: fetchPortfolioManagers,
    groupTypeGroupSorter: (o1, o2) => {
      if (o1.lastName === o2.lastName) {
        if (o1.firstName === o2.firstName) {
          return 0;
        }
        if (!o1.firstName) {
          return -1;
        }
        if (!o2.firstName) {
          return 1;
        }
        return o1.firstName > o2.firstName ? 1 : -1;
      }
      if (!o1.lastName || o1.lastName === "") {
        return 1;
      }
      if (!o2.lastName || o2.lastName === "") {
        return -1;
      }
      return o1.lastName > o2.lastName ? 1 : -1;
    },
  },
  [GroupType.GROUP]: {
    value: GroupType.GROUP,
    label: "Entity Groups",
    groupingValue: "group",
    groupingKey: "entityId",
    comboboxValueKey: "entityId",
    comboboxLabelKey: "name",
    groupPickerColumnDefs: [
      {
        headerName: "Entity ID",
        field: "entityId",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Major",
        field: "major",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Minor",
        field: "minor",
        width: 60,
      },
      {
        headerName: "Name",
        field: "name",
      },
    ],
    fetchGroups: async ({ asOfDate }) => {
      const json = (
        await exchange({
          baseURL: process.env.REACT_APP_BASE_URL_ENTITY_SERVICE,
          url: "rest/query/type/Attributes.json",
          params: {
            entityDates: asOfDate,
            select: "entityId,major,minor,name",
            where: "type = 'GROUP'",
            appName: process.env.REACT_APP_ID,
          },
        })
      )?.data;

      return json?.results ?? [];
    },
    groupTypeGroupSorter: (o1, o2) => {
      return o1.name > o2.name ? 1 : -1;
    },
  },
  [GroupType.COMP]: {
    value: GroupType.COMP,
    label: "Composite Groups",
    groupingValue: "comp",
    groupingKey: "entityId",
    comboboxValueKey: "entityId",
    comboboxLabelKey: "name",
    groupPickerColumnDefs: [
      {
        headerName: "Entity ID",
        field: "entityId",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Major",
        field: "major",
        width: 60,
        suppressSizeToFit: true,
      },
      {
        headerName: "Minor",
        field: "minor",
        width: 60,
      },
      {
        headerName: "Name",
        field: "name",
      },
    ],
    fetchGroups: async ({ asOfDate }) => {
      const json = (
        await exchange({
          baseURL: process.env.REACT_APP_BASE_URL_ENTITY_SERVICE,
          url: "rest/query/type/Attributes.json",
          params: {
            entityDates: asOfDate,
            select: "entityId,major,minor,name",
            where: "type = 'COMP'",
            appName: process.env.REACT_APP_ID,
          },
        })
      )?.data;

      return json?.results ?? [];
    },
    groupTypeGroupSorter: (o1, o2) => {
      return o1.name > o2.name ? 1 : -1;
    },
  },
};

export default GroupType;
export { GroupTypeEntity };
